import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi, IResponseApiSearch } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
import type { tipoGeneralesVinculaciones, IConfPersonasEmpleadosVincu } from '@/modules/Administracion/interfaces'
export class PersonaEmpleadoVincuService extends BaseService<IConfPersonasEmpleadosVincu> {
  constructor () {
    super({
      baseUrl: 'system/employee-links/'
    })
  }
  async searchEmpleadoVincu (
    id: number | string,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApiSearch<IConfPersonasEmpleadosVincu[]>>> {
    return this.http
      .get<IResponseApiSearch<IConfPersonasEmpleadosVincu[]>>(`/search/${id}`, { params })
      .catch(this.errorHandle)
  }
  async getGenerales(): Promise<AxiosResponse<IResponseApi<tipoGeneralesVinculaciones>>> {
    return this.http.get<IResponseApi<tipoGeneralesVinculaciones>>(`/general`)
  }
}
